import React from 'react';
import Link from 'components/Link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { decodeString, generateElementKey } from 'lib/stringUtils';

import styles from './styles.module.scss';

const attributionHtml = (attribution) => (
  <span className="black" data-test="blockquote-attribution">{decodeString(attribution)}</span>
);

const hasSourceLink = (source, attribution) => {
  if (source) {
    return (
      <Link
        href={source}
        target="_blank"
        rel="noopener noreferrer"
        data-test="blockquote-source"
      >
        {attributionHtml(attribution)}
      </Link>
    );
  }
  return attributionHtml(attribution);
};

function BlockQuote({ text, attribution, source }) {
  return (
    <section
      className={classNames(styles.blockquoteContainer, 'relative w-auto mv8 gray-60 blockQuoteContainer')}
    >
      <blockquote
        className={classNames(styles.bq, 'fs-italic ma0')}
        cite={attribution}
      >
        {decodeString(text).split(/[\n\r]+/).map((graph) => (
          <p key={generateElementKey(graph)}>
            {graph}
          </p>
        ))}
        <small className="founders-mono f2 fs-normal ttu db mt5 gray-80">
          {hasSourceLink(source, attribution)}
        </small>
      </blockquote>
    </section>
  );
}

BlockQuote.propTypes = {
  text: PropTypes.string.isRequired,
  attribution: PropTypes.string,
  source: PropTypes.string,
};

BlockQuote.defaultProps = {
  attribution: null,
  source: null,
};

export default BlockQuote;
